/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/jquery/jquery.extensions.d.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var Analytics = (function () {
            function Analytics($, location, analytics, analyticsLibrary) {
                this.$ = $;
                this.location = location;
                this.analytics = analytics;
                this.analyticsLibrary = analyticsLibrary;
            }
            Analytics.prototype.getCurrentAnalyticsPageName = function () {
                if (this.$.isNullOrUndefined(this.analytics.PageName)) {
                    return "";
                }
                return this.analytics.PageName;
            };
            Analytics.prototype.getCurrentPageName = function () {
                var pageName = this.getCurrentAnalyticsPageName();
                if (pageName.length === 0) {
                    pageName = this.location.pathname;
                }
                return pageName;
            };
            Analytics.prototype.getSiteId = function () {
                return this.analyticsLibrary.getSiteId();
            };
            return Analytics;
        }());
        Header.Analytics = Analytics;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=header-analytics.js.map
